import { AttrField, OrmModel, StringField } from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'

@OrmModel(modelNames.RECIPIENT_FILTERED_VIEW)
export default class RecipientFilteredView<T extends boolean = boolean> extends BaseModel {
  @StringField()
  public id: string

  @AttrField()
  public name: T extends true ? null : string

  @AttrField()
  public membersCount: T extends true ? null : number

  @AttrField()
  public isSystem: T extends true ? null : boolean

  @AttrField()
  public isDeleted: T
}
